import type { PendingComment, RootState } from './reducers/types';

// Shared empty fallbacks so a PR with no entry yields a stable reference and
// useSelector doesn't re-render on every dispatch.
const EMPTY_COMMENTS: PendingComment[] = [];
const EMPTY_PAGES: number[] = [];

// Auth
export const tokenSelector = (state: RootState) => state.auth.token;

// Comments — factory because the result depends on which PR is active
export const commentsForPrSelector =
  (prNumber: number) => (state: RootState) =>
    state.comments.byPr[String(prNumber)] ?? EMPTY_COMMENTS;

// Review
export const activePageForPrSelector =
  (prNumber: number) => (state: RootState) =>
    state.review.activePage[String(prNumber)] ?? 0;

export const approvedPagesForPrSelector =
  (prNumber: number) => (state: RootState) =>
    state.review.approved[String(prNumber)] ?? EMPTY_PAGES;
